<template>
  <div style="position:relative;margin-top:80px;margin-bottom:20px">
    <h2><span class="function-title">行程信息提交成功</span></h2>
    <br />
    <Card style="width:320px;margin:0 auto">
        <div style="text-align:center">
            <img src="http://www.baonengjet.com/wp-content/themes/generalbusiness_free/images/two-dimensional.jpg">
            <h3>尊敬的客户，您的行程信息提交成功!我司将尽快与您联系。扫码二维码关注宝能公务可以获得更多信息！</h3>
        </div>
    </Card>
  </div>
</template>

<script>
/* eslint-disable */
  
  export default {
    name: 'jet-qutoes-success',
    data() {
      return {

      }
    },
    watch: {

    },
    mounted() {
 
    },
    methods: {
     
    }
  }

</script>
<style scoped>
  @import '../assets/styles/app.css';

</style>



// WEBPACK FOOTER //
// src/view/jet-quotes-success.vue